import React, { useEffect, useState } from "react";
import Seo from "../components/Seo";
import { useParams, useSearchParams } from "react-router-dom";
import axios from "axios";
import he from "he";

const ProductPage = () => {
  const [productData, setProductData] = useState({});
  const { id } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const category = searchParams.get("category");
  const [isLoading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    getProductData();
  }, []);

  const getProductData = async () => {
    //console.log(subcategoryName, "Sub Category Nameee");
    console.log(id);
    setLoading(true);
    try {
      const res = await axios.get(
        //`https://bioraiz.in/bioraiz_admin/api/catebypro/${id}`
        `https://test.bioversalremedies.com/bioversal_remedies_admin/api/subbypro/${category}`
      );

      const filteredData = res.data.filter((item) => item.name === id);

      console.log("ProductData", res.data);
      console.log("Product", filteredData);
      setProductData(filteredData[0]);
      // if (catClick.length > 0) {
      // } else {
      //   setProductData(res.data);
      // }

      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  return (
    <div>
      <Seo
        title={`${id} | Bioversal Remedies`}
        description="The Best Pharma Products in the World"
        type="webapp"
        name="Bioversal Remedies"
      />
      <div>
        <section className="container animate__animated animate__fadeIn">
          <div className="row product__container">
            {/* Product Image */}
            <div className="col-md-6 col-sm-12 text-center mb-4 mb-md-0">
              <div
                id="productCarousel"
                className="carousel slide"
                data-bs-ride="carousel"
              >
                <div className="carousel-inner">
                  <div className="carousel-item active">
                    <img
                      src={productData?.image}
                      className="d-block carousel-image"
                      alt={productData?.name}
                    />
                  </div>
                  <div className="carousel-item">
                    {/* {productData?.visual_aid && ( */}
                    <img
                      src={productData?.visual_aid}
                      className="d-block carousel-image"
                      alt="Visual Aid"
                    />
                    {/* )} */}
                  </div>
                </div>

                {productData?.visual_aid && (
                  <>
                    {/* Controls */}
                    <button
                      className="carousel-control-prev"
                      type="button"
                      data-bs-target="#productCarousel"
                      data-bs-slide="prev"
                    >
                      <span
                        className="carousel-control-prev-icon"
                        style={{ backgroundColor: "#000" }}
                        aria-hidden="true"
                      ></span>
                      <span className="visually-hidden">Previous</span>
                    </button>
                    <button
                      className="carousel-control-next"
                      type="button"
                      data-bs-target="#productCarousel"
                      data-bs-slide="next"
                    >
                      <span
                        className="carousel-control-next-icon"
                        style={{ backgroundColor: "#000" }}
                        aria-hidden="true"
                      ></span>
                      <span className="visually-hidden">Next</span>
                    </button>
                  </>
                )}
              </div>
            </div>

            {/* Product Info */}
            <div className="col-md-6">
              <h1 className="product-title mb-4 11111">{productData?.name}</h1>
              <hr className="heading-bottom" />

              <div className="row g-3">
                <div className="col-12">
                  <div className="detail-card">
                    <h6>Composition</h6>
                    <p>{productData?.composition}</p>
                  </div>
                </div>
                <div className="col-6">
                  <div className="detail-card">
                    <h6>Category</h6>
                    <p>{productData?.category}</p>
                  </div>
                </div>
              
                <div className="col-6">
                  <div className="detail-card">
                    <h6>Size</h6>
                    <p>{productData?.size}</p>
                  </div>
                </div>
                <div className="col-12">
                  <div className="detail-card">
                    <h6>Package Type</h6>
                    <p>{productData?.package_type}</p>
                  </div>
                </div>
                <div className="col-12">
                  <div className="detail-card">
                    <h6>Description</h6>
                    <p>
                      {productData?.description ? (
                        <span
                          dangerouslySetInnerHTML={{
                            __html: he.decode(productData?.description),
                          }}
                        />
                      ) : (
                        "No description available"
                      )}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <button
          className="back-to-top fa fa-chevron-up"
          style={{ display: "none" }}
        />
      </div>
    </div>
  );
};

export default ProductPage;
